import Config from '../../config';

const initialState = {
    current: Config.language,
    items: [],
    select: []
};

export default (state = initialState, action) => {
    switch (action.type) {
        case 'GET_GLOBALS':
        case 'SET_LANGUAGES':
            const select = [];

            let found = false;
            let currentLang = state.current;
            let firstLang = state.current;

            if (action.payload.languages.length>0){
                firstLang = action.payload.languages[0].code;
            }

            action.payload.languages.forEach((language) => {
                if (currentLang === language.code){
                    found = true;
                }
                select.push({
                    id: language.code,
                    title: language.code
                });
            });

            return {
                ...state,
                items: action.payload.languages,
                select: select,
                current: found ? currentLang : firstLang
            };
            
        case 'SET_LANGUAGE':
            return {
                ...state,
                current: action.payload.language
            };
            
        default:
            return state;
    }
};


// WEBPACK FOOTER //
// ./src/core/store/reducers/language.js